import { useI18nContext } from "@i18n/i18n-react";
import { T } from "@i18n/T";
import { Button } from "@shadcn/ui/button";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Rocket } from "lucide-react";
import { PageContainer } from "~/components/layout/PageContainer";

export const Route = createFileRoute("/one-delivery/onboarding/coming-soon")({
	beforeLoad: () => {
		document.title = "bacehub | One Delivery";
	},
	component: RouteComponent,
});

export default function RouteComponent() {
	const i18n = useI18nContext().LL["new-ui"];
	const navigate = useNavigate();

	return (
		<PageContainer
			className="px-6 mt-2 flex flex-col items-center justify-center"
			footer={
				<Button className="w-full shadow-xl" size="lg" onClick={() => navigate({ to: "/" })}>
					<T>{i18n.OD_COMING_SOON_HOME()}</T>
				</Button>
			}
		>
			<div className="flex flex-col items-center gap-6 text-center py-12">
				<div className="relative">
					<div className="absolute inset-0 bg-primary/20 blur-3xl rounded-full" />
					<Rocket className="size-24 text-primary relative" />
				</div>

				<div className="space-y-4">
					<h1 className="text-3xl font-breit">
						<T>{i18n.OD_COMING_SOON_TITLE()}</T>
					</h1>

					<p className="text-muted-foreground text-lg">
						<T>{i18n.OD_COMING_SOON_TEXT()}</T>
					</p>
				</div>
			</div>
		</PageContainer>
	);
}
